import { getCategory } from "./factories";

export function isTourData(
  data: Travelguide.Outdooractive.POIData
): data is Travelguide.Outdooractive.TourData {
  return "startingPoint" in data;
}

export function isNatureData(
  data: Travelguide.Outdooractive.POIData
): data is Travelguide.Outdooractive.POIData {
  return Boolean(getCategory(data).category.activity?.slug === "naturatlas");
}

export function isAccomodationData(
  data: Travelguide.Outdooractive.POIData
): data is Travelguide.Outdooractive.AccomodationData {
  return "lodging" in data;
}
